import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalTitle,
  CButton,
  CSpinner
} from "@coreui/react";
import { toastr } from "react-redux-toastr";

import JitsiStudent from "../../../../components/Jitsi/student";
import JitsiTeacher from "../../../../components/Jitsi/teacher";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

const Dropbox = require("dropbox");

class JitsiModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recording: "stopped",
      jitsiObj: null
    };
  }

  error(response) {
    toastr.error("Falha", response);
  }

  componentDidMount() {
    if (this.props.teacher) {
      const accessToken =
        "rPBbXAhYoLUAAAAAAAAAAdyTictsKm-4CKuVCU3UVvnvxh11jSGVFjwJxsjZMqpM";

      this.dbx = new Dropbox.Dropbox({ accessToken });
    }
  }

  startRecording() {
    this.state.jitsiObj.executeCommand("startRecording", {
      mode: "file", // recording mode, either `file` or `stream`.
      dropboxToken:
        "G4iT-YvT89EAAAAAAAAAATWTYTblO14JCRYNjWyZ1pFqurouqiGQDVXc6M2rqkR3" // Generated access token
    });

    this.setState({ recording: "starting" });
  }

  stopRecording() {
    this.state.jitsiObj.executeCommand("stopRecording", "file");
    this.setState({ recording: "stopping" });
  }

  onStartRecording() {
    this.setState({ recording: "started" });
  }

  onStopRecording() {
    this.setState({ recording: "stopped" });

    const name = this.props.room;

    const dropBd = async nome => {
      const caminho = await this.dbx.filesListFolder({
        path: "/recordings"
      });

      let nomeDaSala = nome;
      const arquivos = caminho.result.entries; // array de de objetos(files)
      const ultimoArquivo = arquivos.length - 1; // posicao do último arquivo no array

      let pathDoArquivo;
      for (let i = ultimoArquivo; i >= 0; i--) {
        let nomeDoArquivo = arquivos[i].name;
        let nomeTratado = nomeDoArquivo.slice(0, nomeDaSala.length);

        if (nomeTratado === nomeDaSala) {
          pathDoArquivo = arquivos[i].path_lower;
          break;
        }
      }

      this.dbx
        .sharingCreateSharedLinkWithSettings({ path: pathDoArquivo })
        .then(response => {
          const retornoUrl = response.result.url;

          axios
            .post(
              `${URL.api}community/room_recording/insertJitsi`,
              { room_id: this.props.room_id, link: retornoUrl },
              { headers: { Authorization: `Bearer ${this.props.token}` } }
            )
            .then(
              resp => {
                if (!resp.data.success) {
                  this.error("Não foi possível salvar a gravação!");
                }
              },
              error => {
                this.error("Não foi possível salvar a gravação!");
              }
            );
        })
        .catch(error => {
          alert("Já existe um link compartilhável para essa URL");
        });
    };

    setTimeout(() => {
      dropBd(name);
    }, 11200);
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={this.props.onClose}
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader className="d-flex align-items-center" closeButton>
          <CModalTitle>{this.props.title}</CModalTitle>
          {this.props.teacher && (
            <CButton
              color={
                ["started", "stopping"].includes(this.state.recording)
                  ? "danger"
                  : "modal"
              }
              className="d-flex justify-content-center align-items-center px-2 py-1 ml-3"
              onClick={() =>
                this.state.recording === "started"
                  ? this.stopRecording()
                  : this.startRecording()
              }
            >
              {this.state.recording === "stopped" ? (
                <>
                  <i className="fa fa-circle text-danger mr-2"></i> Gravar
                </>
              ) : this.state.recording === "started" ? (
                <>
                  <i className="fa fa-square mr-2"></i> Parar
                </>
              ) : this.state.recording === "starting" ? (
                <>
                  <CSpinner size="sm" color="danger" className="mr-2" />{" "}
                  Iniciando gravação...
                </>
              ) : (
                <>
                  <CSpinner size="sm" color="white" className="mr-2" /> Parando
                  gravação...
                </>
              )}
            </CButton>
          )}
        </CModalHeader>
        {this.props.show && (
          <>
            {this.props.teacher ? (
              <JitsiTeacher
                room={this.props.room}
                user={this.props.user}
                className="w-100 h-100"
                onStartRecording={() => this.onStartRecording()}
                onStopRecording={() => this.onStopRecording()}
                onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
              />
            ) : (
              <JitsiStudent
                room={this.props.room}
                user={this.props.user}
                className="w-100 h-100"
                onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
              />
            )}
            <ProtectedRoute routeId={this.props.currentRoute} />
          </>
        )}
      </CModal>
    );
  }
}

export default JitsiModal;
